var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "datetime",
    title: "Accounting DateTime",
    description: "UTC date and time in YYYYMMDDHHMMSS format.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    fields: {
        min: {
            title: "Minimum Datetime",
            type: "string"
        },
        max: {
            title: "Maximum Datetime",
            type: "string"
        }
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ min: "20250601000000", max: "20250630120000" }, "20250611153045");
            }
        },
        tooEarly: {
            throw: "fields.datetime.outOfRange",
            run: function () {
                return validate({ min: "20250611000000" }, "20250610000000");
            }
        },
        tooLate: {
            throw: "fields.datetime.outOfRange",
            run: function () {
                return validate({ max: "20250612000000" }, "20250613000000");
            }
        },
        invalid: {
            throw: "fields.datetime.invalid",
            run: function () {
                return validate({}, "2025-06-11T15:30:45");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid DateTime",
            description: "Must be in YYYYMMDDHHMMSS format.",
            template: "Invalid datetime '${value}'"
        },
        outOfRange: {
            title: "Datetime Out of Range",
            description: "Datetime must be between specified min and max.",
            template: "Datetime '${value}' is not between ${min} and ${max}"
        }
    }
});

function validate(spec, value) {
    if (typeof value !== "string" || !/^[0-9]{14}$/.test(value)) {
        _.errors.invalid.throw({ value: value });
    }

    if (spec.min && value < spec.min) {
        _.errors.outOfRange.throw({ value: value, min: spec.min, max: spec.max });
    }

    if (spec.max && value > spec.max) {
        _.errors.outOfRange.throw({ value: value, min: spec.min, max: spec.max });
    }
}
module.exports.validate = validate;
